import Service from 'src/service.js';
import store from 'store/store.js';

export default class TimeTrackingModel {
    static changeReport(){
        store.dispatch('changeTimeTracking');
        store.dispatch('changeProjects');
    }
    static setReportValues(year, month){
        Service.getTimeTrackigTotal(month, year);
        Service.getProjectTotal(month, year);
    }

    static changeTasks() {
        store.dispatch('changeTasksMonoceros');
        store.dispatch('changeTasksJira');

        store.dispatch('changeDebts');
    }
    static setTasksValues(current_my, day, id, jira_id) {
        Service.getTasks(current_my, day, id);
        Service.getTasksJira(current_my, day, jira_id);
        Service.getStatuses();
        
        let date = new Date()
        Service.getDebts(date.getDate(), date.getMonth() + 1, date.getFullYear())
    }

    static postWriteOff(data, is_inside, total_time_count, difference){
        Service.postWriteOff(data, is_inside, total_time_count, difference);
    }
    
    static getDate() {
        let full_date = store.getters.currentDate;
        let year = full_date.substr(3, 4);
        let month = full_date.substr(0, 2) - 1;
        return [full_date, year, month];
    }
}


// WEBPACK FOOTER //
// ./src/TimeTrackingModal/TimeTrackingModel.js